import React, { useState } from 'react';
import { apiDelete, apiPatch } from "../../services/api";
import '../styles/BlockActions.css';
import { useNotification } from '../../contexts/NotificationContext';

const BlockActions = ({ block, onBlockUpdated, onBlockDeleted }) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');
  const { showNotification } = useNotification();

  const handleDelete = async () => {
    if (window.confirm(`Вы уверены, что хотите удалить этот блок?`)) {
      setIsDeleting(true);
      setError('');

      try {
        console.log("block.id", block.id);

        await apiDelete(`${process.env.REACT_APP_API_URL}/api/block/${block.id}`);

        try {
          if (onBlockDeleted && typeof onBlockDeleted === 'function') {
            onBlockDeleted(block.id);
          }
          showNotification("Блок успешно удален", "success");
        } catch (error) {
          console.error('Ошибка при вызове функции onBlockDeleted:', error);
        }
      } catch (err) {
        console.error('Ошибка при удалении блока:', err);
        setError(`Ошибка при удалении блока: ${err.response?.data?.message || err.message}`);
        showNotification("Ошибка при удалении блока", "error");
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const handleOrderChange = async (newOrder) => {
    try {
      await apiPatch(`${process.env.REACT_APP_API_URL}/api/block/${block.id}`, {
        order: newOrder
      });

      if (onBlockUpdated && typeof onBlockUpdated === 'function') {
        onBlockUpdated({ ...block, order: newOrder });
      }
      showNotification("Порядок блока обновлен", "success");
    } catch (err) {
      console.error('Ошибка при изменении порядка блока:', err);
      setError(`Ошибка при изменении порядка: ${err.response?.data?.message || err.message}`);
      showNotification("Ошибка при изменении порядка", "error");
    }
  };

  return (
    <div className="block-actions">
      <div className="block-info">
        <span>Тип: {block.type}</span>
        <span>Порядок: {block.order}</span>
      </div>

      <div className="action-buttons">
        <button
          onClick={handleDelete}
          disabled={isDeleting}
          className="delete-button"
        >
          {isDeleting ? 'Удаление...' : 'Удалить'}
        </button>
      </div>

      {error && <div className="action-error">{error}</div>}
    </div>
  );
};

export default BlockActions;